import React from 'react';
import PropTypes from 'prop-types';

import { Tabs, Tab } from 'react-bootstrap';
import { useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';

const VehicleCardTabs = ({ id, tabArray, tabLabels }) => {
	const { widgetName, windowId } = useRequestData();

	return (
		<>
			{tabArray?.length > 1 && (
				<Tabs
					className="vehicle-card-tabs tabs tabs-fill"
					id={id}
					onSelect={(key) =>
						trackEvent(widgetName, windowId, {
							element: `${tabLabels?.[key]} tab`,
							result: 'Tab displayed'
						})
					}
				>
					{tabArray.map((tab) => (
						<Tab
							eventKey={tab.eventKey}
							key={tab.key}
							title={tab.title}
						>
							{tab.component}
						</Tab>
					))}
				</Tabs>
			)}
			{tabArray?.length === 1 && tabArray[0]?.component}
		</>
	);
};

VehicleCardTabs.propTypes = {
	id: PropTypes.string.isRequired,
	tabArray: PropTypes.arrayOf(
		PropTypes.shape({
			eventKey: PropTypes.string,
			key: PropTypes.string,
			title: PropTypes.string,
			component: PropTypes.element
		})
	).isRequired,
	tabLabels: PropTypes.shape({
		info: PropTypes.string,
		pricing: PropTypes.string,
		specials: PropTypes.string
	})
};
export default VehicleCardTabs;
